let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1ruJB"), load("ffEVr"), load("momKe")]).then(() => parcelRequire('csnLw'));